/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import InputError from '../InputError/InputErrorComponent';
import ToolTip from '../Tooltip';

const Select = ({ id, label, touched, errors, handleBlur, tests, options, values, info, addNoneOption }) => {
  const required = tests.find(test => test.OPTIONS.name === 'required');
  const hasValue = values[id] !== '' && values[id] !== undefined;
  const hasError = errors[id] !== undefined;
  const isTouched = touched[id];
  const isInvalid = isTouched && hasError ? 'is-invalid' : null;
  const className = info ? 'input-wrap has-info' : 'input-wrap';

  if (label) {
    return (
      <div className={className}>
        <label htmlFor={id} className={`float ${hasValue && 'is-raised'}`}>
          <span className={`label-text ${hasError && hasValue ? 'is-invalid' : ''}`}>
            {label} {required && '*'}
          </span>
          <Field
            as="select"
            name={id}
            id={id}
            onBlur={handleBlur}
            className={['form-control', isInvalid].join(' ')}
          >
            <option value="" disabled />
            {addNoneOption && (
              <option value="None">
                --None--
              </option>
            )}
            {options &&
              options.map(item => (
                <option value={item.value} key={item.label}>
                  {item.label}
                </option>
              ))}
          </Field>
          <InputError touched={isTouched} message={errors[id]} />
        </label>
        {info && (
          <div className="tooltip-container">
            <ToolTip text={info} />
          </div>
        )}
      </div>
    );
  }

  // No Label Version
  return (
    <div className={className}>
      <Field
        as="select"
        name={id}
        onBlur={handleBlur}
        className={['form-control', isInvalid].join(' ')}
      >
        <option vlaue="" disabled />
        {options &&
          options.map(item => (
            <option value={item.value} key={item.label}>
              {item.label}
            </option>
          ))}
      </Field>
      <InputError touched={isTouched} message={errors[id]} />
      {info && (
        <div className="tooltip-container">
          <ToolTip text={info} />
        </div>
      )}
    </div>
  );
};

Select.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  touched: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  handleBlur: PropTypes.func,
  tests: PropTypes.array,
  options: PropTypes.array,
  addNoneOption: PropTypes.bool,
  values: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  info: PropTypes.string,
};

Select.defaultProps = {
  id: '',
  label: '',
  touched: [],
  errors: [],
  handleBlur: () => { },
  tests: [],
  options: [],
  addNoneOption: false,
  values: [],
};

export default Select;
